import React from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import { getMimeLabel, formatFileSize } from '../utils';
import FileThumbnail from './FileThumbnail';

const useStyles = makeStyles({
  preview: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    marginBottom: 12,
    borderRadius: 8,
    backgroundColor: '#f5f5f5',
    gap: 12,
  },
  fileInfo: {
    minWidth: 0,
    flex: 1,
  },
  fileName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

const FilePreviewCard = ({ name, mimeType, sizeBytes, previewUrl, children }) => {
  const classes = useStyles();

  return (
    <div className={classes.preview}>
      <FileThumbnail mimeType={mimeType} src={previewUrl} />
      <div className={classes.fileInfo}>
        <Typography variant="body2" className={classes.fileName}>
          {name}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {getMimeLabel(mimeType)}
          {sizeBytes ? ` \u00B7 ${formatFileSize(sizeBytes)}` : ''}
        </Typography>
      </div>
      {children}
    </div>
  );
};

FilePreviewCard.propTypes = {
  name: PropTypes.string.isRequired,
  mimeType: PropTypes.string,
  sizeBytes: PropTypes.number,
  previewUrl: PropTypes.string,
  children: PropTypes.node,
};

export default FilePreviewCard;
